(function (appComponents) {

	appComponents.controllers.productDetails = function (Components) {
		var productDetails = {};

		productDetails.name = "productDetails";


		Components.getControllerPrototype().extend(productDetails);

		productDetails._cart = productDetails._getService("cartBase");
		productDetails._modals = productDetails._getService("modals");
		productDetails._b2bUnit = productDetails._getService("b2bUnit");
		productDetails._product = productDetails._getService("productBase");

		productDetails.bindings = function () {

		};

		productDetails.liveBindings = function () {
			$('[pc-container="product-download-datapack--modal"]').on('hidden.bs.modal', function () {
				$('[pc-container="product-download-datapack--modal"] input:checked + .iCheck-helper').click();
			});

			$("[pc-container='product--download-all-form']").off().on("submit", function () {
				var checkedElements = $(this).find("input[type='checkbox']:checked");
				if (!checkedElements.length) {
					productDetails._modals.warning.show(productDetails._messages.noItemsChecked);
					return false;
				} else {
					productDetails.handlers.onDownloadAllDataPacksSubmit(this);
					return false;
				}
			});

			$("[pc-container='product--add-to-cart']").off().click(function () {
				productDetails.handlers.onAddToCart();
			});
			$("[pc-container='product--details-datapack']").off().click(function () {
				var type = $(this).attr("pc-value");
				productDetails.handlers.onDataPackItemClick(type);
			});

			$('.data-pack-heading  li').click(function () {
				$('.pro-details-tab-list').removeClass('active');
				$('.pro-details-tab-list > a').css('background-color', '#005cb9');
				$('.pro-details-tab-list > a').css('color', '#fff');
			});

			$('.pro-details-tab-list').click(function () {
				$('.data-pack-heading  li').removeClass('active');
				$('.pro-details-tab-list > a').css('background-color', '#e3ebf8');
				$('.pro-details-tab-list > a').css('color', '#333');
				$('.pro-details-tab-list').addClass('border-left-fat');
			});
		};

		productDetails.downloadAllDataPacksSubmit = function (codes) {
			var stockId = productDetails.context.product.stockId;
			productDetails._product.downloadArchive(stockId, codes);
		};

		productDetails.handlers = {
			onDataPackItemClick: function (type) {
				var stockId = productDetails.context.product.stockId;
				productDetails._product.downloadDataPack(stockId, type);
			},
			onAddToCart: function () {
				var access = productDetails._b2bUnit.checkB2BUnit();
				var quantity = 1;
				if (null != productDetails.context.product.minOrderQuantity
						&& undefined != productDetails.context.product.minOrderQuantity) {
					quantity = productDetails.context.product.minOrderQuantity;
				}
				if (!access) {
					productDetails._modals.warning.show(productDetails._messages.noB2bUnitSelected);
					return;
					
				}
				var data = {
					productCode: productDetails.context.product.code,
					qty: quantity,
					spa: "" // what should we do with spa on PD page :?
				};

				productDetails._cart.addItems([data]);
			},
			onDownloadAllDataPacksSubmit: function (form) {
				var formData = productDetails._utils.getFormData(form);
				productDetails.downloadAllDataPacksSubmit(formData);
				$('[pc-container="product-download-datapack--modal"]').modal("hide");
			}
		};

		productDetails.init = function () {

			var product = productDetails._stash.selectedProduct;

			productDetails.context.product = product;

			productDetails._renderPageTemplate();

			productDetails._bindings();

			productDetails._applyScript.base.owl();

			productDetails._events.dispatchEvent("controllerInitialized");
		};

		return productDetails;
	};

	window.appComponents = appComponents;

})(window.appComponents || {});